"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var CustomLoader =
/*#__PURE__*/
function () {
  function CustomLoader(_ref) {
    var loaderSelector = _ref.loaderSelector,
        nodeSelector = _ref.nodeSelector;

    _classCallCheck(this, CustomLoader);

    this.loader = $(loaderSelector);

    if (!this._initialized()) {
      this.loader = this.loader.dxLoadPanel({
        shadingColor: "rgba(255,255,255,0.8)",
        position: {
          of: nodeSelector
        },
        visible: false,
        showIndicator: true,
        showPane: false,
        shading: true,
        message: '',
        closeOnOutsideClick: false
      });
    }
  }

  _createClass(CustomLoader, [{
    key: "_initialized",
    value: function _initialized() {
      return this.loader && this.loader.data('dxLoadPanel');
    }
  }, {
    key: "instance",
    value: function instance() {
      return $(this.loader).dxLoadPanel('instance');
    }
  }, {
    key: "show",
    value: function show() {
      if (this._initialized() && !this.visible()) return this.instance().show();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this._initialized() && this.visible()) return this.instance().hide();
    }
  }, {
    key: "visible",
    value: function visible() {
      return this._initialized() && this.instance().option('visible');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._initialized()) this.instance().dispose();
      this.loader.remove();
    }
  }]);

  return CustomLoader;
}();